import { InjectionToken } from '@angular/core';

export type GemFeedbackChatbotLauncher = () => void | Promise<void>;

/**
 * Host app (e.g. uwl-frontend) can provide this token to enable the chatbot entry within GemFeedbackComponent.
 */
export const GEM_FEEDBACK_CHATBOT_LAUNCHER = new InjectionToken<GemFeedbackChatbotLauncher>(
  'gem-feedback.chatbot-launcher',
);

